<!-- prettier-ignore -->
<template>
    <v-app id="login" class="white">
        <v-main>
            <v-container fluid fill-height>
                <v-layout align-center justify-center>
                    <v-flex xs12 sm8 md4 lg4>
                        <v-toolbar dark color="primary">
                            <v-toolbar-title>Login form</v-toolbar-title>
                        </v-toolbar>
                        <v-card class="elevation-1 pa-3">
                            <v-card-text>
                                <v-form>
                                    <v-text-field append-icon="person" label="Email" type="text"
                                                  v-model="auth.username"/>
                                    <v-text-field append-icon="lock" label="Password" type="password"
                                                  v-model="auth.password"/>
                                </v-form>
                            </v-card-text>
                            <v-card-actions>
                                <v-btn block color="primary" @click="loginWithEmail" :loading="loading">Login</v-btn>
                            </v-card-actions>
                            <!--                            <v-card-actions>-->
                            <!--                                <v-btn block color="error" @click="loginWithGoogle">Sing in With Google</v-btn>-->
                            <!--                            </v-card-actions>-->
                        </v-card>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-main>
    </v-app>
</template>

<script>
    export default {
        data: () => ({
            auth: {
                username: null,
                password: null,
                provider: null,
            }
        }),
        computed: {
            error() {
                return this.$store.state.error;
            },
            loading() {
                return this.$store.state.loading;
            }
        },
        created() {
            this.$store.commit("setError", null);
        },
        methods: {
            loginWithEmail() {
                this.auth.provider = "email";
                window.app.$emit("APP_LOGIN", this.auth);
            },
            loginWithGoogle() {
                this.auth.provider = "google";
                window.app.$emit("APP_LOGIN", this.auth);
            }
        }
    };
</script>

<style scoped lang="css">
    #login {
        height: 50%;
        width: 100%;
        position: absolute;
        top: 0;
        left: 0;
        content: "";
        z-index: 0;
    }
</style>
